import * as z from "zod";

export const disconnectOkendoIntegration = {
  name: "disconnectOkendoIntegration" as const,
  input: z.null(),
  output: z.null(),
};
